module.exports = __webpack_public_path__ + "static/img/downloadBg.fb2b77f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/downloadBg.jpg
// module id = tmpc
// module chunks = 0